import * as actionTypes from "./types";

import { axiosInstance, environment } from "../../utils/util.axios";
import { LOADING, ERROR } from "./types";

// ---------------- CHECK AUTH ------------------------------

export const setLoading = (value) => {
    return {
        type: actionTypes.LOADING,
        payload: value,
    };
};


// ---------------- SERVER ERROR ------------------------------

export const setIsSSOEnabled = () => async (dispatch) => {
    try {
        const response = await axiosInstance.get("/sso_enabled");
        dispatch({ 
            type: actionTypes.SET_IS_SSO_ENABLED,
            payload: response.data.success === 1
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: actionTypes.SET_IS_SSO_ENABLED,
            payload: false
        });
    }
};

export const handleSSOError = (message) => (dispatch) => {
    console.error(message);
    dispatch(enqueueSnackbar({
        message,
        options: {
            key: new Date().getTime() + Math.random(),
            variant: "error",
            autoHideDuration: 10000,
        },
    }));
};


// ---------------- SAVE URL TO REDIRECT AFTER LOGIN ------------------------------

export const saveUrlFrom = (value) => {

    switch (value) {
    case "platform":
        sessionStorage.setItem("source", "platform");
        return {
            type: actionTypes.SET_SOURCE,
            source: value,
            redirect: process.env.REACT_APP_FRONTEND_URL,
        };
    case "trials":
        sessionStorage.setItem("source", "trials");
        return {
            type: actionTypes.SET_SOURCE,
            source: value,
            redirect: process.env.REACT_APP_TRIALS_URL,
        };
    case "care":
        sessionStorage.setItem("source", "care");
        return {
            type: actionTypes.SET_SOURCE,
            source: value,
            redirect: process.env.REACT_APP_CARE_URL,
        };
    default:
        return {};
    }
};


// ---------------- SNACKBAR ACTIONS ------------------------------

const enqueueSnackbar = (notification) => {
    const key = notification.options && notification.options.key;

    return {
        type: actionTypes.ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random(),
        },
    };
};

export const closeSnackbar = key => ({
    type: actionTypes.CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
});

export const removeSnackbar = key => ({
    type: actionTypes.REMOVE_SNACKBAR,
    key,
});


// ---------------- SET COOKIE ------------------------------

export const setCookieModal = () => {
    return {
        type: actionTypes.SET_COOKIE_MODAL
    };
};

// ---------------- SET POSITION_Y ------------------------------

export const showOnScroll = (value) => {
    return {
        type: actionTypes.SET_SHOW_ON_SCROLL,
        payload: value
    };
};


// ---------------- CHECK IF IT IS AUTHENTICATED ------------------------------

export const setAuthentication = () => async (dispatch) => {
    axiosInstance
        .post(`${process.env.REACT_APP_BACKEND_URL}/me`, {}, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(async (response) => {
            const session = response.data;
            if (response.status !== 200 || session.success !== 1) {
                localStorage.removeItem("session_active");
                dispatch({
                    type: actionTypes.SET_SESSION,
                    payload: false
                });
            } else {
                if (session.success === 1) {
                    dispatch({
                        type: actionTypes.SET_SESSION,
                        payload: [
                            session.user_data,
                            true
                        ]
                    });
                }
            }
        })
        .catch((error) => {
            throw error;
        });
};


// ---------------- ERROR CODE ATTEMPTS------------------------------

export const setErrorAttempts = () => {
    return {
        type: actionTypes.SET_ERROR_ATTEMPTS,
    };
};

// ---------------- ERROR CODE ------------------------------

export const errorCode = (value) => {
    return {
        type: actionTypes.SET_ERROR_CODE,
        payload: value
    };
};

// ---------------- LOGOUT ------------------------------

export const logout = (redirectTo = "/") => async (dispatch) => {
    axiosInstance
        .post("/logout", {}, {
            withCredentials: true,
            headers: { "Content-Type": "application/json" }
        })
        .then((response) => {
            let session = response.data;
            if (session.success === 1) {
                localStorage.removeItem("session_active");
                localStorage.removeItem("token");
                localStorage.removeItem("qmenta-global-state");
                window.location.replace(redirectTo);
            } else {
                //  console.log("FIX STATUS CODE RESPONSE ON THE BACKEND");
                dispatch(enqueueSnackbar({
                    message: session.error,
                    options: {
                        key: new Date().getTime() + Math.random(),
                        variant: "error"
                    },
                }));
            }
        })
        .catch((error) => {
            // Log the error but delete cookies anyway
            // Session may be invalid or expired
            console.error({error});
            localStorage.removeItem("session_active");
            localStorage.removeItem("token");
            localStorage.removeItem("qmenta-global-state");
            window.location.replace(redirectTo);
        });
};

// ---------------- ACTIVATE USER WITH ACTIVATION CODE ----------------

export const activateUserWithCode = (activationCode, errorCounter, setRegisterButtonEvent) => async (dispatch) => {
    dispatch(errorCode(false));
    setRegisterButtonEvent(LOADING);
    axiosInstance
        .post(
            `${environment}/a_user_manager/activate_user_with_code`,
            {
                "activation_code": activationCode
            },
            {
                withCredentials: true
            }
        )
        .then((response) => {
            let data = response.data;
            if (data.success === 1) {
                // User can access Platform, redirect to Dojo
                window.location.replace(process.env.REACT_APP_FRONTEND_URL);
            } else {
                setRegisterButtonEvent(ERROR);
                if (errorCounter === 2) {
                    dispatch(logout());
                }
                dispatch(errorCode(true));  // Display error message
                dispatch(setErrorAttempts(true));  // Increment errorCounter
            }
        })
        .catch((error) => {
            console.error({error});
            // Unexpected error. User session is invalid or is using wrong cookie-header pair
            dispatch(setLoading(false));
            setRegisterButtonEvent(ERROR);
            dispatch(logout());
        });
};